import { useEffect, useRef } from "react";
import { useAuth } from "@/lib/auth";
import { Navigate, useLocation } from "react-router-dom";
import { useWahaSession, useRefreshWahaStatus } from "@/hooks/use-waha-session";
import { useOnboardingStatus } from "@/hooks/use-onboarding-status";
import { useApprovalStatus } from "@/hooks/use-approval-status";
import { PageSkeleton } from "@/components/PageSkeleton";
import { PendingApprovalScreen } from "@/components/PendingApprovalScreen";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const { data: wahaSession } = useWahaSession(false);
  const refreshStatus = useRefreshWahaStatus();
  const hasCheckedRef = useRef(false);
  const { isCompleted: onboardingDone, isLoading: onboardingLoading } = useOnboardingStatus();
  const { isApproved, isLoading: approvalLoading } = useApprovalStatus();

  // Verification live initiale : si la DB dit WORKING, checker le statut reel
  useEffect(() => {
    if (wahaSession?.status === "WORKING" && !hasCheckedRef.current) {
      hasCheckedRef.current = true;
      refreshStatus.mutate();
    }
  }, [wahaSession?.status]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <PageSkeleton />;
  if (!user) return <Navigate to="/login" replace />;

  // Bloquer si l'email n'est pas confirme
  if (!user.email_confirmed_at) return <Navigate to="/login" replace />;

  // Bloquer si le compte n'est pas valide par le superadmin
  if (approvalLoading) return <PageSkeleton />;
  if (!isApproved) return <PendingApprovalScreen />;

  // Don't redirect if already on onboarding page (avoid loop)
  if (pathname === "/onboarding") return <>{children}</>;

  // Attendre le statut onboarding avant de decider
  if (onboardingLoading) return <PageSkeleton />;

  // Onboarding non complete → rediriger vers /onboarding
  if (!onboardingDone) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
